import React from 'react';
import { useTrainingTranslation } from './hooks/useTrainingTranslation';
import EraSection from './EraSection';
import TrainingHeader from './header/TrainingHeader';
import CourseGrid from './courses/CourseGrid';
import TrainingRequestForm from './request/TrainingRequestForm';
import CustomTrainingCTA from './cta/CustomTrainingCTA';
import Card from '../common/Card';

const TrainingSection = () => {
  const { getTranslation } = useTrainingTranslation();
  const translation = getTranslation();

  return (
    <div id="training">
      <EraSection />

      <div className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <TrainingHeader />

          <div className="mt-16">
            <CourseGrid />
          </div>

          <div id="training-request" className="mt-16 scroll-mt-24">
            <Card className="max-w-4xl mx-auto">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900">
                  {translation.request.title}
                </h3>
                <p className="mt-2 text-gray-600">
                  {translation.request.subtitle}
                </p>
              </div>
              <TrainingRequestForm />
            </Card>
          </div>

          <div className="mt-12">
            <CustomTrainingCTA />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainingSection;
